import React from 'react'
import * as styles from './Container.module.scss'

const Container = ({ children }) => {
  return (
    <div className={styles.section}>
      <div className={styles.content}>{children}</div>
    </div>
  )
}

export default Container
